// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2VVYO","header":"Messages_header__pyhto"};